export const types = {
  MODAL_DISPLAYED: 'MODAL_DISPLAYED',
  MODAL_HIDDEN: 'MODAL_HIDDEN',
  INITIAL_LISTS_LOADED: 'INITIAL_LISTS_LOADED',
  NEW_LIST_SAVED: 'NEW_LIST_SAVED',
  UPDATED_LIST_SAVED: 'UPDATED_LIST_SAVED',
  LIST_CREATED: 'LIST_CREATED',
  LIST_DELETED: 'LIST_DELETED',
  ALL_LISTS_DELETED: 'ALL_LISTS_DELETED',
  LIST_SELECTED: 'LIST_SELECTED',
  TITLE_UPDATED: 'TITLE_UPDATED',
  ITEM_ADDED: 'ITEM_ADDED',
  ITEM_DELETED: 'ITEM_DELETED',
  ITEM_UPDATED: 'ITEM_UPDATED',
  ITEM_COMPLETED: 'ITEM_COMPLETED',
  ITEM_MARKED_INCOMPLETE: 'ITEM_MARKED_INCOMPLETE',
  VIEW_CHANGED: 'VIEW_CHANGED',
};
